module.exports = __webpack_public_path__ + "resources/increase-size-97e9cd751933c04628d1ae8604ff9f1a.svg";